// Jersey Perro — interactividad de las secciones propias (mt-*)
(function () {
  'use strict';

  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initGaleriaProducto() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-galeria-principal]');
      var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-full');
          var alt = mini.getAttribute('data-alt') || '';
          if (!src) return;
          principal.src = src;
          principal.alt = alt;
          minis.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
          mini.classList.add('mt-mini-activa');
        });
      });
    });
  }

  function initSelectorVariantes() {
    document.querySelectorAll('[data-mt-producto-form]').forEach(function (wrap) {
      var dataEl = wrap.querySelector('[data-mt-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try {
        variantes = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      var selects = wrap.querySelectorAll('[data-mt-opcion]');
      var idInput = wrap.querySelector('[data-mt-id-input]');
      var precioEl = wrap.querySelector('[data-mt-precio]');
      var precioTachado = wrap.querySelector('[data-mt-precio-tachado]');
      var botonComprar = wrap.querySelector('[data-mt-boton-comprar]');
      var avisoAgotado = wrap.querySelector('[data-mt-agotado]');
      var scope = wrap.closest('.mt-prod') || document;
      var imgPrincipal = scope.querySelector('[data-mt-galeria-principal]');
      var minis = scope.querySelectorAll('[data-mt-galeria-mini]');

      function encontrarVariante() {
        var valores = [];
        selects.forEach(function (s) { valores.push(s.value); });
        return variantes.find(function (v) {
          return v.options.every(function (opt, i) { return opt === valores[i]; });
        });
      }

      function actualizar() {
        var v = encontrarVariante();
        if (!v) return;
        idInput.value = v.id;
        if (precioEl) precioEl.textContent = v.precio_formateado;
        if (precioTachado) {
          if (v.precio_comparado_formateado) {
            precioTachado.textContent = v.precio_comparado_formateado;
            precioTachado.hidden = false;
          } else {
            precioTachado.hidden = true;
          }
        }
        if (botonComprar) {
          botonComprar.disabled = !v.disponible;
          var textoSpan = botonComprar.querySelector('[data-mt-boton-texto]');
          var texto = v.disponible
            ? botonComprar.getAttribute('data-texto-disponible')
            : botonComprar.getAttribute('data-texto-agotado');
          if (textoSpan) textoSpan.textContent = texto;
        }
        if (avisoAgotado) avisoAgotado.hidden = v.disponible;
        if (imgPrincipal && v.imagen) {
          imgPrincipal.src = v.imagen;
          imgPrincipal.srcset = '';
          imgPrincipal.alt = v.imagen_alt || imgPrincipal.alt;
          minis.forEach(function (m) {
            m.classList.toggle('mt-mini-activa', m.getAttribute('data-full') === v.imagen);
          });
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
      actualizar();
    });
  }

  function initContador() {
    var els = document.querySelectorAll('[data-mt-contador]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var fin = parseInt(el.getAttribute('data-mt-contador'), 10) || 0;
          var dur = 1400;
          var inicio = null;
          function paso(ts) {
            if (!inicio) inicio = ts;
            var progreso = Math.min((ts - inicio) / dur, 1);
            el.textContent = Math.round(fin * (1 - Math.pow(1 - progreso, 3)));
            if (progreso < 1) requestAnimationFrame(paso);
          }
          requestAnimationFrame(paso);
          obs.unobserve(el);
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initGaleriaProducto();
    initSelectorVariantes();
    initContador();
  });
})();
